import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./Loader";

export default function PageLoader({ children }) {

  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 900); // tempo entre páginas

    return () => clearTimeout(timer);

  }, [location.pathname]);

  if (loading) return <Loader />;

  return children;
}